const RETRYABLE_ERROR_CODES = new Set(['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK']);
const RETRYABLE_STATUS_CODES = new Set([502, 503, 504]);
const DEFAULT_READY_TTL_MS = 5 * 60 * 1000;

export function isRetryableBackendError(error) {
  if (!error) return false;
  if (RETRYABLE_ERROR_CODES.has(error.code)) return true;
  const status = Number(error.response?.status);
  return RETRYABLE_STATUS_CODES.has(status);
}

export async function withBackendWakeup(action, wakeup, shouldRetry = isRetryableBackendError) {
  try {
    return await action();
  } catch (error) {
    if (!shouldRetry(error)) throw error;
    await wakeup(error);
    return action();
  }
}

export function createBackendReadiness(check, { ttlMs = DEFAULT_READY_TTL_MS } = {}) {
  let readyUntil = 0;
  let inFlight = null;

  return () => {
    if (Date.now() < readyUntil) return Promise.resolve();
    if (inFlight) return inFlight;

    inFlight = Promise.resolve()
      .then(check)
      .then(result => {
        readyUntil = Date.now() + ttlMs;
        return result;
      })
      .finally(() => {
        inFlight = null;
      });

    return inFlight;
  };
}
